import { Controller } from "@hotwired/stimulus"

// Subtle, dismissible bypass confirm. When the user submits with a red (everyday-words)
// keyword, the first submit is intercepted and an inline warning expands above the submit
// button. A second submit, or clicking "Create anyway", proceeds. Nothing sticky: state
// resets per form render, and editing the keyword back to specific clears it.
export default class extends Controller {
  static targets = ["warning"]

  #worstTier = null
  #confirmed = false

  verdict(event) {
    this.#worstTier = event.detail.tier
    if (this.#worstTier !== "very_common") this.#hide()
  }

  guard(event) {
    if (this.#confirmed || this.#worstTier !== "very_common") return
    event.preventDefault()
    this.#show()
  }

  confirm() {
    this.#confirmed = true
    this.#hide()
    this.element.requestSubmit()
  }

  #show() {
    if (this.hasWarningTarget) this.warningTarget.hidden = false
  }

  #hide() {
    if (this.hasWarningTarget) this.warningTarget.hidden = true
  }
}
